export const environment = {
  production: false,
  apiUrl: 'https://api-booth.xrossoversports.com/api',
  
  reverbKey:    '4ab0738d5e1317d80c4843ded7acc31f',
  reverbHost:   'ws-booth.xrossoversports.com',
  reverbPort:   443,
  reverbScheme: 'https',

  boothChannel: 'booth.xrossover-main',
};